// extracted by mini-css-extract-plugin
export default {"indicator":"DropdownIndicator-module__indicator__Gfo3b"};